import React, { useEffect, useMemo } from "react";
import {
  View,
  FlatList,
  Platform,
  TouchableOpacity,
  Image,
} from "react-native";
import { NEXT_ICON, PREV_ICON } from "../../resources/IMAGES";
import DocumentListItem from "../../components/docs/DocumentListItem";
import { ids, styles } from "./Style";

interface PdfItemProps {
  documentsArray: any[];
  currentIndex: number;
  moveNextPreviousHorizontalFlatlist: (isNext: boolean) => void;
  flatListRef: React.RefObject<FlatList>;
  onViewableItemsChanged: (info: any) => void;
  onPdfItemTap: (item: any) => void;
}

const PdfItem: React.FC<PdfItemProps> = ({
  documentsArray,
  currentIndex,
  moveNextPreviousHorizontalFlatlist,
  flatListRef,
  onViewableItemsChanged,
  onPdfItemTap,
}) => {
  const isWeb = Platform.OS === "web";

  const NavigationArrow = ({
    isLeft,
    isDisabled,
    onPress,
  }: {
    isLeft: boolean;
    isDisabled: boolean;
    onPress: () => void;
  }) => (
    <View
      style={isLeft ? styles.RefreshLeft : styles.RefreshRight}
      dataSet={{ media: isLeft ? ids.RefreshLeft : ids.RefreshRight }}
      testID={`docs-page-navigation-arrow-${isLeft ? 'left' : 'right'}`}
    >
      <TouchableOpacity onPress={onPress} disabled={isDisabled}>
        <Image
          style={
            isDisabled
              ? styles.arrowDisable
              : isLeft
              ? styles.Prev
              : styles.Next
          }
          dataSet={{
            media: isDisabled ? ids.arrowDisable : isLeft ? ids.Prev : ids.Next,
          }}
          source={isLeft ? PREV_ICON : NEXT_ICON}
          resizeMode="contain"
        />
      </TouchableOpacity>
    </View>
  );
  useEffect(() => {
    if (Platform.OS == "web") {
      setTimeout(() => {
        if (flatListRef?.current && documentsArray?.length>0)
          flatListRef.current?.scrollToIndex({ index: currentIndex });
      }, 800);
    }
  }, []);
  const DocumentItem = useMemo(
    () =>
      React.memo(({ item, index }: { item: any; index: number }) => (
        <DocumentListItem
          documentDetails={item}
          index={index}
          onItemPress={async () => onPdfItemTap(item)}
        />
      )),
    [onPdfItemTap]
  );
  const ITEM_WIDTH = 280;
  return (
    <View style={styles.cardScrollar} dataSet={{ media: ids.cardScrollar }}>
      {isWeb && documentsArray.length > 2 && (
        <NavigationArrow
          isLeft={true}
          isDisabled={currentIndex === 0}
          onPress={() => moveNextPreviousHorizontalFlatlist(false)}
        />
      )}

      <FlatList
        ref={flatListRef}
        onViewableItemsChanged={onViewableItemsChanged}
        showsHorizontalScrollIndicator={false}
        horizontal
        keyExtractor={(item, index) => index.toString()}
        data={documentsArray}
        getItemLayout={(_, index) => ({
          length: ITEM_WIDTH,
          offset: ITEM_WIDTH * index,
          index,
        })}
        renderItem={({ item, index }) => (
          <DocumentItem item={item} index={index} />
        )}
        contentContainerStyle={{margin:'auto'}}
      />

      {isWeb && documentsArray.length > 2 && (
        <NavigationArrow
          isLeft={false}
          isDisabled={currentIndex === documentsArray.length - 2}
          onPress={() => moveNextPreviousHorizontalFlatlist(true)}
        />
      )}
    </View>
  );
};

export default PdfItem;
